// PURP ALERT RADIO — music library
// ---------------------------------------------------------------------------
// HOW TO ADD A SONG OR MY 5 AUDIO DROP:
//   1. Put the audio file (mp3 recommended) in:  frontend/public/audio/
//   2. Add one entry per track to TRACKS below, e.g.:
//
//   {
//       id: "my-first-single",                 // unique, kebab-case
//       title: "My First Single",
//       artist: "PURP ALERT",
//       kind: "song",                          // "song" or "my5-drop"
//       src: "/audio/my-first-single.mp3",     // file you dropped in step 1
//       cover: "/brand/radio-logo.webp",       // optional — defaults to radio logo
//   },
//
// Every track card shows an "ADD TO YOUR PLAYLIST" button (Spotify / Apple
// Music / YouTube logos) that opens LINKTREE_URL below — update that one
// link and every track updates automatically.
// Nothing is published until it is listed here — no placeholders, no fakes.
// ---------------------------------------------------------------------------

export const LINKTREE_URL = "https://linktr.ee/PURPALERTNETWORK";

export const TRACKS = [
    {
        id: "rent-due-dreams-too",
        title: "Rent Due, Dreams Too",
        artist: "Purp Alert",
        kind: "song",
        src: "/audio/rent-due-dreams-too.wav",
        cover: "/brand/cover-rent-due.webp",
    },
    {
        id: "gold-covered-truth",
        title: "Gold Covered Truth",
        artist: "Purp Alert",
        kind: "song",
        src: "/audio/gold-covered-truth.wav",
        cover: "/brand/cover-gold-truth.webp",
    },
];
